import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { FIELD_LABEL_CLASSES, SELECT_STYLING_PROPS } from "@/constants/forms"
import type { CompanyInfoFileType } from "@/screens/Companies/edit/components/info/constants"
import { CompanyFileTypeMap } from "@/screens/Companies/edit/components/info/constants"

const options = Object.entries(CompanyFileTypeMap).map(([key, value]) => (
  <MenuItem key={key} value={key}>
    {value.label}
  </MenuItem>
))

const FileTypeSelect: FC<{
  name: string
}> = ({ name }) => {
  const methods = useFormContext()

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <FormControl fullWidth data-testid={name}>
          <InputLabel id={name} className={FIELD_LABEL_CLASSES}>
            File Type<span className='text-red-600'>*</span>
          </InputLabel>
          <Select
            {...SELECT_STYLING_PROPS}
            {...field}
            labelId={name}
            defaultValue={field.value}
            renderValue={(key: CompanyInfoFileType) => {
              if (!key) {
                return <span className='text-gray-500'>Select One</span>
              }

              return CompanyFileTypeMap[key].label ?? ""
            }}
          >
            {options}
          </Select>
        </FormControl>
      )}
    />
  )
}

export default FileTypeSelect
